<template>
  <div class="message-list-container">
    <div class="message-list-header">
      <input
        id="searchMessage"
        v-model="searchKeywords"
        type="text"
      >
      <label for="searchMessage">
        <svg-icon
          slot="icon"
          class="icon"
          name="search"
          color="black"
        />
      </label>
      <div
        class="chatbox-close-btn"
        @click="closeChatBox"
      >
        <i
          class="isif isif-close"
        />
      </div>
    </div>
    <div class="message-list-body">
      <div
        v-if="newCaseConversationId"
        class="message-item new-message"
        @click="selectConversation(newCaseConversationId)"
      >
        {{ $t('instantMessaging.startConversation') }}
        <i class="isif isif-arrow-right" />
      </div>
      <template v-for="conversation in searchResultConversations">
        <div
          :key="conversation.conversationId"
          class="message-item"
          @click="selectConversation(conversation.conversationId)"
        >
          <div class="item-content">
            <p class="ellipsis">
              {{ conversation.caseName }}
            </p>
            <p class="ellipsis">
              {{ displayMessageText(conversation) }}
            </p>
          </div>
          <div class="item-info">
            <p>{{ displayDate(conversation.timestamp) }}</p>
            <span
              v-if="conversation.unread"
              class="unread"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InstantMessagingChat from '@/plugins/talkjs'
import SvgIcon from '../../components/SvgIcon/index.vue'

const ChatInstance = InstantMessagingChat.getOrInitInstance()

export default {
  name: 'MessageList',

  components: {
    SvgIcon
  },

  data () {
    return {
      searchKeywords: ''
    }
  },

  computed: {
    ...mapGetters([
      'user',
      'property',
      'currentBuilding',
      'qaList',
      'conversations'
    ]),

    newCaseConversationId () {
      try {
        const currentCaseConversationId = ChatInstance.getCurrentCaseConversation().id
        const currentCaseConversation = this.conversations.find(conversation => conversation.conversationId === currentCaseConversationId)
        if (!currentCaseConversation) {
          return currentCaseConversationId
        }
        return null
      } catch (error) {
        return null
      }
    },

    sortedConversations () {
      return [...this.conversations].sort((a, b) => b.timestamp - a.timestamp)
    },

    searchResultConversations () {
      return this.sortedConversations.filter(conversation => {
        return conversation.caseName.indexOf(this.searchKeywords) > -1 ||
        this.displayMessageText(conversation).indexOf(this.searchKeywords) > -1
      })
    }
  },

  beforeMount () {
    this.fetchConversation()
  },

  methods: {
    ...mapActions([
      'toggleChatbox',
      'fetchConversation',
      'setCurrentConversationId'
    ]),
    closeChatBox () {
      this.toggleChatbox(false)
    },
    displayDate (date) {
      const targetDate = this.$moment(date).format('MM/DD')
      const now = this.$moment().format('MM/DD')
      if (targetDate === now) {
        return this.$moment(date).format('MM/DD HH:mm')
      }
      return this.$moment(date).format('MM/DD HH:mm')
    },

    selectConversation (id) {
      if (id === this.newCaseConversationId) {
        ChatInstance.toggleHtmlPanel(true)
      } else {
        ChatInstance.toggleHtmlPanel(false)
      }
      ChatInstance.switchConversation(id)
      this.setCurrentConversationId(id)
    },

    displayMessageText (conversation) {
      return conversation.type === 'text'
        ? conversation.lastMessage
        : conversation.type === 'media'
          ? this.$t('instantMessaging.mediaMessage')
          : conversation.type === 'location'
            ? this.$t('instantMessaging.locationMessage')
            : ''
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.chatbox-close-btn{
  top: auto;
}

.message-list-container {
  border-radius: 5px
  width: 360px
  max-height: 600px
  height: 90vh
  position: absolute
  right: 0
  bottom: 0
  background-color: $white
  overflow-y: scroll
}

.message-list-header {
  width: 100%
  text-align: center
  padding: 10px 16px
  background-color: #E7ECEE
  display: flex
  align-items: center

  input {
    outline: none
    border: 1px solid #999
    border-radius: 20px
    padding: 0 12px
    font-size: 1rem
    height: 32px
  }

  label {
    padding-left: 8px
    flex: 0 0
    cursor: pointer
  }
}

.message-list-body {
  width: 100%
  display: flex
  justify-content: space-around
  align-items: center
  flex-wrap: wrap
  overflow-y: auto

  .message-item:nth-child(odd) {
    background-color: lightness(#1E60E1, 80%)
  }

  .message-item:nth-child(even) {
    background-color: lightness(#1E60E1, 90%)
  }
}

.message-item {
  display: flex
  justify-content: space-between
  width: 100%
  padding: 8px 16px
  cursor: pointer

  p {
    color: $black
    text-shadow: none
    text-align: left
  }
}

.item-content {
  width: 50%
  flex: 1 1

  :nth-child(1) {
    font-weight: bold
    margin-bottom: 6px
  }
  :nth-child(2) {
    font-size: 0.9rem
  }
}

.item-info {
  flex: 0 0 auto

  p {
    font-size: 0.9rem
    margin-bottom: 6px
  }

  .unread {
    display: inline-block
    width: 12px
    height: 12px
    border-radius: 8px
    background: linear-gradient(225deg, $light-pink-color 50%, $pink-color)
  }
}

.ellipsis {
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
}

.new-message {
  padding: 20px 16px
}
</style>
